import axios from './request';

// 商家管理
export function associationPage(data) {
  return axios.request({
    proxyName: "bff-supplier",
    url: "/association/page",
    method: "POST",
    data,
  });
}
// 详情
export function associationGet(params) {
    return axios.request({
      proxyName: "bff-supplier",
      url: "/association/get",
      method: "GET",
      params,
    });
  }

//   同意

export function associationAgree(data) {
    return axios.request({
      proxyName: "bff-supplier",
      url: "/association/agree",
      method: "POST",
      data,
    });
  }

//   终止合作
export function associationTerminated(data) {
    return axios.request({
      proxyName: "bff-supplier",
      url: "/association/terminated",
      method: "POST",
      data,
    });
  }

  // 编辑
  export function associationEdit(data) {
    return axios.request({
      proxyName: "bff-supplier",
      url: "/association/reject",
      method: "POST",
      data,
    });
  }